function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_x0020_1"
}, React.createElement("path", {
  className: "st0",
  d: "M9.2,11.1c-0.4,0.3-0.8,0.6-1.3,1L7,12.8l-0.2-0.2c-1.7-1.2-3.3-2.5-4.6-3.7C0.9,7.5,0,6.2,0,4.8 c0-0.8,0.4-1.5,1.1-2.1C1.8,2.3,2.7,2,3.7,2C5.3,2,6.2,2.5,7,3.6c0.3-0.4,0.7-0.8,1.2-1.1C8.7,2.2,9.4,2,10.3,2 c1,0,1.9,0.3,2.6,0.8C13.6,3.3,14,4.1,14,4.8c0,0.6-0.2,1.2-0.5,1.8c-0.3,0.6-0.7,1.1-1.2,1.7l-0.6-0.5c0.4-0.5,0.8-1,1.1-1.5 c0.2-0.4,0.4-0.9,0.4-1.4c0-0.6-0.3-1.1-0.8-1.5c-0.5-0.4-1.3-0.6-2.1-0.6C9.5,2.7,9,2.9,8.5,3.2C8.1,3.4,7.7,3.9,7.3,4.4L7,4.9 L6.7,4.4C6,3.3,5.2,2.7,3.7,2.7C2.8,2.7,2.1,3,1.6,3.4C1,3.8,0.7,4.3,0.7,4.8c0,1.1,0.8,2.3,1.9,3.5c1.2,1.2,2.7,2.4,4.3,3.5 l0.4-0.3c0.4-0.4,0.9-0.7,1.3-1L9.2,11.1z M10.1,11.8V10H8.2V9.2h1.8V7.4h0.8v1.8h1.8V10h-1.8v1.9H10.1z"
}));

var SvgAddToFavorites = function SvgAddToFavorites(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddToFavorites, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addToFavorites.701824c7.svg";
export { ForwardRef as ReactComponent };